import "pinia";

declare module "pinia" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface DefineStoreOptionsBase<S, Store> {
    onLoad?: (this: Store) => any;
  }
}
export const initStorePlugin = (context) => {
  context.options.onLoad?.call(context.store);
};

export default initStorePlugin;
